import { styled } from '@mui/material/styles';

const style = {
    Container: styled('div')`
        align-items: center;
        display: flex;
        flex: 1;
        justify-content: center;
    `,
};

export default style;
